// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require("./bootstrap");
require("formdata-polyfill");
require("jquery-ui-sortable-npm");
import "./scss/app.scss";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import VuejsDialog from "vuejs-dialog";
import AsyncComputed from "vue-async-computed";
import VueScrollTo from "vue-scrollto";
import draggable from "vuedraggable";
import router from "./router";
import VueBootstrapDatePicker from "vue-bootstrap-datetimepicker";

Vue.use(VueScrollTo);
Vue.use(BootstrapVue);
Vue.use(VueBootstrapDatePicker);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VuejsDialog);
Vue.use(AsyncComputed);
Vue.component("draggable", draggable);
Vue.component("vue-multiselect", require("vue-multiselect").default);
Vue.component("draggable", require("vuedraggable").default);
Vue.component("sidebar", require("./components/Sidebar").default);
Vue.component("action-bar", require("./components/ActionBar").default);
Vue.component("project-list", require("./components/ProjectList").default);
Vue.component(
  "long-text-input",
  require("./components/Parts/Input/LongText").default
);
Vue.component(
  "entity-multiselect",
  require("./components/EntityMultiselect").default
);
Vue.component("text-input", require("./components/Parts/Input/Text").default);
Vue.component("file-input", require("./components/Parts/Input/File").default);
Vue.component("researchers", require("./components/Researchers").default);
Vue.component(
  "markdown-editor",
  require("./components/MarkdownEditor").default
);
Vue.component("loading", require("./components/Loading").default);

Vue.config.productionTip = false;

require("./stores/admin");

const app = new Vue({ router, template: "<router-view></router-view>" }).$mount(
  "#app"
);

store.dispatch("login");



// WEBPACK FOOTER //
// ./src/main.js